export const clientFields = [
  { name: "name", label: "Empresa / nombre", required: true },
  { name: "contact_name", label: "Contacto" },
  { name: "phone", label: "Teléfono", type: "tel" },
  { name: "email", label: "Correo", type: "email" },
  { name: "address", label: "Dirección", type: "textarea", rows: 2 },
  { name: "status", label: "Estado", type: "select", default: "activo", options: [{ value: "activo", label: "Activo" }, { value: "inactivo", label: "Inactivo" }] },
  { name: "notes", label: "Observaciones", type: "textarea", rows: 2 },
];

export const siteFields = [
  { name: "name", label: "Nombre del sitio", required: true },
  { name: "address", label: "Dirección", type: "textarea", rows: 2 },
  { name: "contact_name", label: "Contacto" },
  { name: "phone", label: "Teléfono", type: "tel" },
];

export const projectFields = (meta, zones = []) => [
  { name: "name", label: "Nombre del proyecto", required: true },
  { name: "business_unit_code", label: "Unidad de negocio", type: "select", options: (meta?.business_units || []).map((b) => ({ value: b.code, label: b.name })) },
  { name: "address", label: "Dirección del sitio", type: "textarea", rows: 2 },
  { name: "zone_id", label: "Zona del proyecto", type: "select", nullable: true, noneLabel: "Sin zona", options: zones.filter((z) => z.active).map((z) => ({ value: z.id, label: z.path })) },
  { name: "environment", label: "Ambiente", type: "select", default: "normal", options: (meta?.environments || []).map((e) => ({ value: e.code, label: e.label })) },
  { name: "status", label: "Estado", type: "select", default: "activo", options: [{ value: "activo", label: "Activo" }, { value: "concluido", label: "Concluido" }, { value: "cancelado", label: "Cancelado" }] },
  { name: "notes", label: "Observaciones", type: "textarea", rows: 2 },
];

export const pick = (obj, fields) => Object.fromEntries(fields.map((f) => [f.name, obj?.[f.name]]));
